import { atom } from "jotai";

/** Ask O's drawer width on a wide window. */
export const O_ASK_DRAWER_PX = 400;

/** Below this window width the drawer takes the whole width, over the page. */
export const O_ASK_NARROW_PX = 900;

/**
 * From this window width the page leaves the drawer's width free, so save bars, side panels and
 * the canvas stay usable beside it. Narrower, the base planogram page (about 880 px of content
 * beside the sidebar) can't fit next to the drawer, so the drawer lies over the page instead.
 */
export const O_ASK_DOCK_PX = 1360;

/** Ask O's drawer is open on this page. */
export const oAskDockedAtom = atom(false);
